"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldCmd = exports.COLLA_COMMAND_MAP = exports.CollaCommandName = void 0;
const datasheet_1 = require("./datasheet");
const widget_1 = require("./widget");
const dashboard_1 = require("./dashboard");
const form_1 = require("./form");
const manual_save_view_1 = require("../commands/datasheet/manual_save_view");
const set_view_auto_save_1 = require("../commands/datasheet/set_view_auto_save");
const reset_records_1 = require("./datasheet/reset_records");
var CollaCommandName;
(function (CollaCommandName) {
    CollaCommandName["AddFields"] = "AddFields";
    CollaCommandName["AddRecords"] = "AddRecords";
    CollaCommandName["SetRecords"] = "SetRecords";
    CollaCommandName["SetFieldAttr"] = "SetFieldAttr";
    CollaCommandName["PasteSetFields"] = "PasteSetFields";
    CollaCommandName["PasteSetRecords"] = "PasteSetRecords";
    CollaCommandName["MoveViews"] = "MoveViews";
    CollaCommandName["ModifyViews"] = "ModifyViews";
    CollaCommandName["DeleteViews"] = "DeleteViews";
    CollaCommandName["AddViews"] = "AddViews";
    CollaCommandName["MoveRow"] = "MoveRow";
    CollaCommandName["DeleteRecords"] = "DeleteRecords";
    CollaCommandName["MoveColumn"] = "MoveColumn";
    CollaCommandName["DeleteField"] = "DeleteField";
    CollaCommandName["SetSortInfo"] = "SetSortInfo";
    CollaCommandName["SetRowHeight"] = "SetRowHeight";
    CollaCommandName["SetAutoHeadHeight"] = "SetAutoHeadHeight";
    CollaCommandName["SetColumnsProperty"] = "SetColumnsProperty";
    CollaCommandName["SetViewFilter"] = "SetViewFilter";
    CollaCommandName["SetViewLockInfo"] = "SetViewLockInfo";
    CollaCommandName["SetViewFrozenColumnCount"] = "SetViewFrozenColumnCount";
    CollaCommandName["SetGroup"] = "SetGroup";
    CollaCommandName["SetGalleryStyle"] = "SetGalleryStyle";
    CollaCommandName["SetGanttStyle"] = "SetGanttStyle";
    CollaCommandName["SetOrgChartStyle"] = "SetOrgChartStyle";
    CollaCommandName["SetCalendarStyle"] = "SetCalendarStyle";
    CollaCommandName["FillDataToCells"] = "FillDataToCells";
    CollaCommandName["FixConsistency"] = "FixConsistency";
    // special command, used for some special records to set data only in the middle layer to fix the data consistency problem
    CollaCommandName["SystemSetRecords"] = "SystemSetRecords";
    // special command, used for some special fields to set attributes only in the middle layer to fix the data consistency problem
    CollaCommandName["SystemSetFieldAttr"] = "SystemSetFieldAttr";
    CollaCommandName["SetKanbanStyle"] = "SetKanbanStyle";
    CollaCommandName["InsertComment"] = "InsertComment";
    CollaCommandName["UpdateComment"] = "UpdateComment";
    CollaCommandName["DeleteComment"] = "DeleteComment";
    CollaCommandName["SystemCorrectComment"] = "SystemCorrectComment";
    CollaCommandName["Rollback"] = "Rollback";
    // widgetPanel
    CollaCommandName["AddWidgetPanel"] = "AddWidgetPanel";
    CollaCommandName["MoveWidgetPanel"] = "MoveWidgetPanel";
    CollaCommandName["ModifyWidgetPanelName"] = "ModifyWidgetPanelName";
    CollaCommandName["DeleteWidgetPanel"] = "DeleteWidgetPanel";
    CollaCommandName["AddWidgetToPanel"] = "AddWidgetToPanel";
    CollaCommandName["DeleteWidget"] = "DeleteWidget";
    CollaCommandName["ChangeWidgetInPanelHeight"] = "ChangeWidgetInPanelHeight";
    CollaCommandName["MoveWidget"] = "MoveWidget";
    // Widget
    CollaCommandName["SetGlobalStorage"] = "SetGlobalStorage";
    CollaCommandName["SetWidgetName"] = "SetWidgetName";
    // Dashboard
    CollaCommandName["AddWidgetToDashboard"] = "AddWidgetToDashboard";
    CollaCommandName["ChangeDashboardLayout"] = "ChangeDashboardLayout";
    CollaCommandName["DeleteDashboardWidget"] = "DeleteDashboardWidget";
    CollaCommandName["SetWidgetDepDstId"] = "SetWidgetDepDstId";
    // Form
    CollaCommandName["UpdateFormProps"] = "UpdateFormProps";
    // Date cell alarm
    CollaCommandName["SetDateTimeCellAlarm"] = "SetDateTimeCellAlarm";
    // Manually save the view configuration
    CollaCommandName["ManualSaveView"] = "ManualSaveView";
    // Modify the save mode of the configuration
    CollaCommandName["SetViewAutoSave"] = "SetViewAutoSave";
    // special command, correct one-way association DstId
    CollaCommandName["FixOneWayLinkDstId"] = "FixOneWayLinkDstId";
    // Only used for Fusion API for reload recordMap
    CollaCommandName["ResetRecords"] = "ResetRecords";
})(CollaCommandName = exports.CollaCommandName || (exports.CollaCommandName = {}));
exports.COLLA_COMMAND_MAP = {
    [CollaCommandName.AddFields]: datasheet_1.addFields,
    [CollaCommandName.AddRecords]: datasheet_1.addRecords,
    [CollaCommandName.SetRecords]: datasheet_1.setRecords,
    [CollaCommandName.SetFieldAttr]: datasheet_1.setFieldAttr,
    [CollaCommandName.PasteSetFields]: datasheet_1.pasteSetFields,
    [CollaCommandName.PasteSetRecords]: datasheet_1.pasteSetRecords,
    [CollaCommandName.MoveViews]: datasheet_1.moveViews,
    [CollaCommandName.ModifyViews]: datasheet_1.modifyViews,
    [CollaCommandName.DeleteViews]: datasheet_1.deleteViews,
    [CollaCommandName.AddViews]: datasheet_1.addViews,
    [CollaCommandName.MoveRow]: datasheet_1.moveRow,
    [CollaCommandName.DeleteRecords]: datasheet_1.deleteRecord,
    [CollaCommandName.DeleteField]: datasheet_1.deleteField,
    [CollaCommandName.MoveColumn]: datasheet_1.moveColumn,
    [CollaCommandName.SetSortInfo]: datasheet_1.setSortInfo,
    [CollaCommandName.SetRowHeight]: datasheet_1.setRowHeight,
    [CollaCommandName.SetAutoHeadHeight]: datasheet_1.setAutoHeadHeight,
    [CollaCommandName.SetColumnsProperty]: datasheet_1.setColumnsProperty,
    [CollaCommandName.SetViewFilter]: datasheet_1.setViewFilter,
    [CollaCommandName.SetGroup]: datasheet_1.setGroup,
    [CollaCommandName.SetGalleryStyle]: datasheet_1.setGalleryStyle,
    [CollaCommandName.SetGanttStyle]: datasheet_1.setGanttStyle,
    [CollaCommandName.SetCalendarStyle]: datasheet_1.setCalendarStyle,
    [CollaCommandName.SetOrgChartStyle]: datasheet_1.setOrgChartStyle,
    [CollaCommandName.FillDataToCells]: datasheet_1.fillDataToCell,
    [CollaCommandName.SetKanbanStyle]: datasheet_1.setKanbanStyle,
    [CollaCommandName.InsertComment]: datasheet_1.insertComment,
    [CollaCommandName.UpdateComment]: datasheet_1.updateComment,
    [CollaCommandName.DeleteComment]: datasheet_1.deleteComment,
    [CollaCommandName.AddWidgetPanel]: datasheet_1.addWidgetPanel,
    [CollaCommandName.MoveWidgetPanel]: datasheet_1.moveWidgetPanel,
    [CollaCommandName.ModifyWidgetPanelName]: widget_1.modifyWidgetPanelName,
    [CollaCommandName.DeleteWidgetPanel]: datasheet_1.deleteWidgetPanel,
    [CollaCommandName.AddWidgetToPanel]: datasheet_1.addWidgetToPanel,
    [CollaCommandName.DeleteWidget]: datasheet_1.deleteWidget,
    [CollaCommandName.SetGlobalStorage]: widget_1.setGlobalStorage,
    [CollaCommandName.ChangeWidgetInPanelHeight]: datasheet_1.changeWidgetInPanelHeight,
    [CollaCommandName.SetWidgetName]: widget_1.setWidgetName,
    [CollaCommandName.MoveWidget]: datasheet_1.moveWidget,
    [CollaCommandName.AddWidgetToDashboard]: dashboard_1.addWidgetToDashboard,
    [CollaCommandName.ChangeDashboardLayout]: dashboard_1.changeDashboardLayout,
    [CollaCommandName.DeleteDashboardWidget]: dashboard_1.deleteDashboardWidget,
    [CollaCommandName.SetWidgetDepDstId]: widget_1.setWidgetDepDstId,
    [CollaCommandName.Rollback]: datasheet_1.rollback,
    [CollaCommandName.UpdateFormProps]: form_1.updateFormProps,
    [CollaCommandName.SetViewLockInfo]: datasheet_1.setViewLockInfo,
    [CollaCommandName.ManualSaveView]: manual_save_view_1.manualSaveView,
    [CollaCommandName.SetViewAutoSave]: set_view_auto_save_1.setViewAutoSave,
    [CollaCommandName.FixOneWayLinkDstId]: datasheet_1.fixOneWayLinkDstId,
    [CollaCommandName.SetViewFrozenColumnCount]: datasheet_1.setViewFrozenColumnCount,
    [CollaCommandName.SetDateTimeCellAlarm]: datasheet_1.setDateTimeCellAlarm,
    [CollaCommandName.ResetRecords]: reset_records_1.resetRecords,
};
__exportStar(require("./datasheet"), exports);
exports.FieldCmd = __importStar(require("./common/field"));
//# sourceMappingURL=index.js.map